import styled from 'styled-components';
import tw from 'twin.macro';

const VideoGridStyles = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-6 py-10 sm:py-12 md:py-16`};
`;

export default VideoGridStyles;